function quickAddToCart(variantId, quantity = 1, btn = null) {
  if (btn) {
    btn.disabled = true;
    btn.dataset.label = btn.textContent.trim();
    btn.innerHTML = '<svg class="quick-add-spinner" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg>';
  }

  fetch(`${Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity: quantity
      }]
    })
  })
  .then(response => response.json())
  .then(data => {
    document.dispatchEvent(new CustomEvent('cart:build'));

    const cartToggle = document.querySelector('.js-drawer-open-cart');
    if (cartToggle) {
      cartToggle.click();
    }
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
  })
  .finally(() => {
    if (btn) {
      btn.disabled = false;
      btn.textContent = btn.dataset.label || 'Quick add';
    }
  });
}

// Keep the page where it was when the Rebuy Smart Cart closes. Its scroll lock
// (plus the theme drawer returning focus to the header cart icon) otherwise
// leaves the page scrolled back to the top.
(function () {
  let savedScrollY = window.scrollY;
  let cartOpen = false;

  // Track the position continuously so we still have it if the lock kicks in
  // before the show event reaches us.
  window.addEventListener('scroll', () => {
    if (!cartOpen) savedScrollY = window.scrollY;
  }, { passive: true });

  document.addEventListener('rebuy:smartcart.show', () => {
    cartOpen = true;
  });

  document.addEventListener('rebuy:smartcart.hide', () => {
    const targetY = savedScrollY;
    let userScrolled = false;
    const stop = () => { userScrolled = true; };
    const restore = () => {
      if (!userScrolled && Math.abs(window.scrollY - targetY) > 1) {
        window.scrollTo({ top: targetY, behavior: 'instant' });
      }
    };

    window.addEventListener('wheel', stop, { passive: true, once: true });
    window.addEventListener('touchmove', stop, { passive: true, once: true });

    // Rebuy releases its lock after the close animation, so restore on the next
    // frame and again once the transition has finished.
    requestAnimationFrame(restore);
    setTimeout(restore, 400);
    setTimeout(() => {
      restore();
      cartOpen = false;
      window.removeEventListener('wheel', stop);
      window.removeEventListener('touchmove', stop);
    }, 700);
  });
})();
